import {
  Cell,
  Row,
  Table,
  TableBody,
  TableHead,
  TableHeadCell,
  TableHeadRow,
} from 'components/Table/styledTable';
import { ReplacementStatus } from 'components/ReplacementStatus';

type ItemNotExistProps = {
  data: { itemCode: string }[];
};

export const ItemNotExist = ({ data }: ItemNotExistProps) => (
  <Table>
    <TableHead>
      <TableHeadRow>
        <TableHeadCell width="150px" divider>
          Item code
        </TableHeadCell>
        <TableHeadCell>Description</TableHeadCell>
      </TableHeadRow>
    </TableHead>
    <TableBody>
      {data.map((item, index) => (
        <Row key={`ItemNotExist-${item.itemCode + index}`}>
          <Cell divider>{item.itemCode}</Cell>
          <Cell>
            <ReplacementStatus status="error" fullWidth>
              Can not find product in database. Check item code or contact Sales
              Support
            </ReplacementStatus>
          </Cell>
        </Row>
      ))}
    </TableBody>
  </Table>
);
